import { template } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import Button from 'ui-kit/components/button';
import type { AttrValue } from '@glint/template';
interface Signature {
    Element: HTMLButtonElement;
    Args: {
        title?: unknown;
        disabled?: AttrValue;
        isLoading?: unknown;
        isReadOnly?: unknown;
    };
}
const SubmitButton: TOC<Signature> = template(`
  {{#unless @isReadOnly}}
    <Button
      class='primary fluid form-button {{if @isLoading "loading"}}'
      type='submit'
      disabled={{@disabled}}
      data-test-next-button
      formnovalidate
      ...attributes
    >
      {{if @title @title 'Sauvegarder'}}
    </Button>
  {{/unless}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default SubmitButton;
